if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        let formData;
        try {
          formData = this.getWalkoPatchFormData(new FormData(this.form));
        } catch (error) {
          this.handleErrorMessage(error.message);
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

          this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }
        
                fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('Impossible de confirmer l’ajout au panier. Vérifiez votre panier avant de réessayer.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      // Keep the optional patch in the same request as its harness.
      // form.elements includes the external input associated via its form attribute.
      getWalkoPatchFormData(formData) {
        const field = Array.from(this.form.elements).find((element) =>
          element.hasAttribute('data-walko-patch-variant-id')
        );
        if (!field) return formData;

        const text = field.value.trim();
        formData.delete(field.name);
        if (!text) return formData;

        const patchId = field.dataset.walkoPatchVariantId;
        if (!/^\d+$/.test(patchId || '')) {
          throw new Error('Le patch personnalisé est momentanément indisponible. Effacez le prénom pour commander le harnais seul.');
        }

        let indexes = [...new Set(Array.from(formData.keys()).flatMap((key) => {
          const match = key.match(/^items\[(\d+)\]\[id\]$/);
          return match ? [Number(match[1])] : [];
        }))];
        if (indexes.length === 0) {
          if (!/^\d+$/.test(formData.get('id') || '')) {
            throw new Error('Veuillez sélectionner la taille et la couleur du harnais.');
          }
          indexes = [0];
          formData.set('items[0][id]', formData.get('id'));
          formData.set('items[0][quantity]', formData.get('quantity') || '1');
          if (formData.get('selling_plan')) {
            formData.set('items[0][selling_plan]', formData.get('selling_plan'));
          }
          for (const [key, value] of Array.from(formData.entries())) {
            const property = key.match(/^properties\[(.*)\]$/);
            if (property) {
              formData.set(`items[0][properties][${property[1]}]`, value);
              formData.delete(key);
            }
          }
        }
        // Avoid sending both the single-item and multi-item request formats.
        ['id', 'quantity', 'selling_plan'].forEach((key) => formData.delete(key));
        let patchQuantity = 0;
        indexes.forEach((index) => {
          const quantity = Number(formData.get(`items[${index}][quantity]`) || 1);
          if (!Number.isInteger(quantity) || quantity < 1) {
            throw new Error('Veuillez sélectionner une quantité valide.');
          }
          patchQuantity += quantity;
          formData.set(`items[${index}][properties][Prénom sur le patch]`, text);
        });
        const patchIndex = Math.max(...indexes) + 1;
        formData.set(`items[${patchIndex}][id]`, patchId);
        formData.set(`items[${patchIndex}][quantity]`, String(patchQuantity));
        formData.set(`items[${patchIndex}][properties][Texte du patch]`, text);
        return formData;
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
